module.exports = __webpack_public_path__ + "static/media/hero-image.2c0cd702.png";